<template>
  <v-layout
    id="orderPage"
    column
    class="page"
  >
    <v-row>
      <v-col>
        <h4 class="text-h4">
          {{ $t('global.order') }} #{{ $route.params.id }}
        </h4>
        {{ getStoreName }}
      </v-col>
      <v-col class="text-right d-print-none">
        <v-btn
          small
          color="accent"
          outlined
          @click="printPage"
        >
          <v-icon left>
            mdi-printer
          </v-icon>
          {{ $t('global.print') }}
        </v-btn>
      </v-col>
    </v-row>

    <loader v-if="isLoading" />

    <v-row
      v-if="!isLoading && !getOrder.id"
      class="error--text"
    >
      <v-col class="text-center">
        {{ $t('order.unable_to_load_order') }}
      </v-col>
    </v-row>

    <div v-if="!isLoading">
      <div v-if="getOrder.id">
        <events :order="getOrder" />
        <order-info :order="getOrder" />

        <assign-courier :order="getOrder" />

        <order-details :order="getOrder" />
      </div>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/System/Layout/Loader'
import AssignCourier from './AssignCourier'
import Events from './Events'
import OrderInfo from './OrderInfo'
import OrderDetails from './OrderDetails'
import StoreHelper from './../Helpers/Store'

export default {
  components: {
    AssignCourier,
    Events,
    Loader,
    OrderDetails,
    OrderInfo
  },

  computed: {
    ...mapGetters('order', [
      'getOrder',
      'isLoading'
    ]),

    getStoreName () {
      return StoreHelper.getStoreName(this.getOrder.store)
    }
  },

  mounted () {
    this.$store.dispatch('order/fetchOrder', this.$route.params.id)
  },

  methods: {
    printPage () {
      window.print();
    }
  }
}
</script>

<style lang="scss">
@media print {
  #orderPage {
    padding: 0;
  }
}
</style>
